import React from 'react';
import PropTypes from 'prop-types';

const MAX_LENGTH = 2000;

// 선택한 사례개념화 항목 하나를 작성하는 입력란.
export default function CaseFieldEditor({ field, value, onChange }) {
    return <div className="case-field">
        <label htmlFor={`concept-${field.key}`}>{field.label}{field.required && <span className="case-required" aria-hidden="true"> *</span>}</label>
        <p className="ai-small case-helper" id={`help-${field.key}`}>{field.helper}</p>
        <textarea id={`concept-${field.key}`} aria-describedby={`help-${field.key}`} aria-required={field.required || undefined} rows={12} maxLength={MAX_LENGTH} value={value} onChange={event => onChange(field.key, event.target.value)} />
        <span className="ai-small case-count">{value.length.toLocaleString()} / {MAX_LENGTH.toLocaleString()}</span>
    </div>;
}

CaseFieldEditor.propTypes = {
    field: PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired, helper: PropTypes.string, required: PropTypes.bool }).isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};
